class ProfileCache {
  constructor() {
    this.cacheKey = 'userProfileCache';
    this.cacheDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  }

  // Get cached profile data if valid
  get() {
    try {
      const cached = localStorage.getItem(this.cacheKey);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);
      const now = Date.now();
      const age = now - timestamp;

      // Check if cache is still valid (within 24 hours)
      if (age < this.cacheDuration) {
        return data;
      } else {
        // Cache expired, remove it
        this.clear();
        return null;
      }
    } catch (e) {
      console.error('Failed to get profile cache:', e);
      this.clear();
      return null;
    }
  }

  // Set profile data in cache with current timestamp
  set(data) {
    try {
      const cacheObject = {
        data,
        timestamp: Date.now(),
      };
      localStorage.setItem(this.cacheKey, JSON.stringify(cacheObject));
    } catch (e) {
      console.error('Failed to set profile cache:', e);
    }
  }

  // Check if cache is valid
  isValid() {
    try {
      const cached = localStorage.getItem(this.cacheKey);
      if (!cached) return false;

      const { timestamp } = JSON.parse(cached);
      const now = Date.now();
      const age = now - timestamp;

      return age < this.cacheDuration;
    } catch (e) {
      return false;
    }
  }

  // Clear cache
  clear() {
    try {
      localStorage.removeItem(this.cacheKey);
    } catch (e) {
      console.error('Failed to clear profile cache:', e);
    }
  }
}

// Export singleton instance
export const profileCache = new ProfileCache();
